import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, redirectToSignup } = useAuth();

  const handleGetStarted = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
    } else {
      redirectToSignup();
    }
  };

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <div className="jumbotron bg-light p-5 rounded">
            <div className="text-center mb-4">
              <img
                src="/ratemytalk150.png"
                alt="RateMyTalk Logo"
                height="100"
                className="mb-3"
              />
            </div>
            <h1 className="display-4 text-center">Welcome to RateMyTalk</h1>
            <p className="lead text-center">
              Conference feedback made simple for speakers and organizers
            </p>
            <hr className="my-4" />
            <div className="row">
              <div className="col-md-6">
                <div className="card h-100">
                  <div className="card-body">
                    <h5 className="card-title">
                      <i className="fas fa-microphone text-primary me-2"></i>
                      For Speakers
                    </h5>
                    <ul className="list-unstyled">
                      <li><i className="fas fa-check text-success me-2"></i>Create talks</li>
                      <li><i className="fas fa-check text-success me-2"></i>Get feedback</li>
                      <li><i className="fas fa-check text-success me-2"></i>Track sessions</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100">
                  <div className="card-body">
                    <h5 className="card-title">
                      <i className="fas fa-calendar text-primary me-2"></i>
                      For Organizers
                    </h5>
                    <ul className="list-unstyled">
                      <li><i className="fas fa-check text-success me-2"></i>Manage events</li>
                      <li><i className="fas fa-check text-success me-2"></i>Invite speakers</li>
                      <li><i className="fas fa-check text-success me-2"></i>View analytics</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center mt-4">
              <button
                className="btn btn-primary btn-lg"
                onClick={handleGetStarted}
              >
                <i className="fas fa-rocket me-2"></i>
                {isAuthenticated ? 'Go to Dashboard' : 'Get Started - Sign Up Now'}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12">
          <h3>Recent Public Events</h3>
          <div className="list-group">
            <div className="list-group-item">
              <i className="fas fa-calendar-alt text-muted me-2"></i>
              TechConf 2024 - London
            </div>
            <div className="list-group-item">
              <i className="fas fa-calendar-alt text-muted me-2"></i>
              DevDays Europe - Amsterdam
            </div>
            <div className="list-group-item">
              <i className="fas fa-calendar-alt text-muted me-2"></i>
              CloudSummit - Berlin
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
